import React, { useState } from 'react';
import { OnboardingWrapper, MultiSelectOption } from '../../../components';
import { useOnboarding } from '../../../data-access';
import { MARKETING_SURVEY_OPTIONS, MarketingSurveyOption } from '../constants';
import './MarketingSurveyPage.scss';

export const MarketingSurveyPage: React.FC = () => {
  const { currentOnboardingStep, goToNextStep, goToPreviousStep, updateSurveyData } =
    useOnboarding();
  const [customValue, setCustomValue] = useState<string>('');

  const [selectedSource, setSelectedSource] = useState<MarketingSurveyOption | null>(null);
  const handleSourceSelect = (source: string) => {
    const selectedOption = MARKETING_SURVEY_OPTIONS.find((option) => option.id === source);
    setSelectedSource(selectedOption);
    setCustomValue('');
  };

  const handleContinue = () => {
    if (selectedSource) {
      const marketingValue = customValue
        ? `${selectedSource.id}_${customValue}`
        : customValue || selectedSource.label;

      updateSurveyData({
        marketing: marketingValue,
      });
      goToNextStep();
    }
  };

  const showTextInput = (item: MarketingSurveyOption) =>
    item.isCustomInput && selectedSource?.id === item.id;

  return (
    <OnboardingWrapper
      currentOnboardingStep={currentOnboardingStep}
      onBack={goToPreviousStep}
      title="How did you find us?"
      buttons={[
        {
          text: 'Continue',
          onPress: handleContinue,
          variant: 'contained',
          disabled: !selectedSource || (selectedSource.id === 'other' && !customValue.trim()),
        },
      ]}
      contentContainerStyle={{ display: 'flex', marginBottom: '15px' }}
    >
      <div className="marketing-survey-page">
        {MARKETING_SURVEY_OPTIONS.map((item) => (
          <MultiSelectOption
            key={item.id}
            value={item.id}
            option={item.label}
            selectedValues={[selectedSource?.id]}
            handleSelect={handleSourceSelect}
            showTextInput={showTextInput(item)}
            placeholder={item.placeholder}
            textInputValue={customValue}
            setTextInputValue={setCustomValue}
            className="marketing-survey-page__option"
          />
        ))}
      </div>
    </OnboardingWrapper>
  );
};
